/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "MaterialSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Material) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "MaterialSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
